import React from 'react';
import { useSelector } from 'react-redux';
import { PopularList } from '../../components/PopularList';
import { selectGeoRegion } from '../../selectors/selectGeoRegion';
import { selectPopularSuburbanLists } from '../../selectors/selectPopularSuburbanLists';

export const PopularListContainer = () => {
  const popularLists = useSelector(selectPopularSuburbanLists);
  const region = useSelector(selectGeoRegion);

  return popularLists.length > 0 ? <PopularList items={popularLists} region={region} /> : null;
};
